import { render, staticRenderFns } from "./CadastroComboDeProcedimentos.vue?vue&type=template&id=0f047ce6&"
import script from "./CadastroComboDeProcedimentos.vue?vue&type=script&lang=js&"
export * from "./CadastroComboDeProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports